import { Button } from '@ctw/shared/components/button';
import { type ClassName, tw, twx } from '@ctw/shared/utils/tailwind';
import { useState } from 'react';

export interface ExpandableTextProps {
  collapsedText: string;
  expandedText: string;
  expandButtonLabel: string;
  className?: ClassName;
}

export const ExpandableText = ({
  collapsedText,
  expandedText,
  expandButtonLabel,
  className,
}: ExpandableTextProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  return (
    <p className={twx(className)}>
      {isExpanded ? expandedText : collapsedText}
      {!isExpanded && (
        <>
          &nbsp;
          <Button
            className={tw`inline`}
            type="button"
            variant="link"
            onClick={(event) => {
              event.stopPropagation();
              setIsExpanded(true);
            }}
          >
            {expandButtonLabel}
          </Button>
        </>
      )}
    </p>
  );
};
